/**
 * Shared "+ New" actions: New document, Import, New folder.
 *
 * Surfaces: empty desk, folder/project context submenu, tab-bar split button.
 * Gallery: /?test=maater-ui#create-in-folder
 */

import { FileDown, FilePlus, FolderPlus, type LucideIcon } from 'lucide-react'

export type CreateInFolderActionId = 'document' | 'import' | 'folder'

export type CreateInFolderTarget = {
  folderPath: string
  workspaceId?: string
}

export const CREATE_IN_FOLDER_TRIGGER_LABEL = 'New'
export const CREATE_IN_FOLDER_SUBMENU_LABEL = 'New'

export const CREATE_IN_FOLDER_ACTIONS: Array<{
  id: CreateInFolderActionId
  label: string
  icon: LucideIcon
}> = [
  { id: 'document', label: 'New document', icon: FilePlus },
  { id: 'import', label: 'Import', icon: FileDown },
  { id: 'folder', label: 'New folder', icon: FolderPlus },
]

export function dispatchCreateInFolder(
  id: CreateInFolderActionId,
  target: CreateInFolderTarget,
): void {
  const folderPath = target.folderPath
  const workspaceDetail = target.workspaceId
    ? { workspaceId: target.workspaceId }
    : {}

  if (id === 'document') {
    window.dispatchEvent(
      new CustomEvent('create-file-at-path', {
        detail: { folderPath, ...workspaceDetail },
      }),
    )
    return
  }

  if (id === 'import') {
    window.dispatchEvent(
      new CustomEvent('import-text-at-path', {
        detail: { folderPath, ...workspaceDetail },
      }),
    )
    return
  }

  window.dispatchEvent(
    new CustomEvent('create-folder-at-path', {
      detail: { parentPath: folderPath },
    }),
  )
}
